import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const OAuthCallbackPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { handleOAuthCallback } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [processing, setProcessing] = useState(true);

  useEffect(() => {
    const processOAuthCallback = async () => {
      const token = searchParams.get('token');
      const sessionError = searchParams.get('error');

      if (sessionError === 'session_invalid') {
        setError('Authentication session invalid. Please sign in again.');
        setProcessing(false);
        setTimeout(() => {
          navigate('/auth/login', { replace: true });
        }, 2000);
        return;
      }
      
      if (!token) {
        setError('No authentication token received');
        setProcessing(false);
        setTimeout(() => {
          navigate('/auth/login', { replace: true });
        }, 2000);
        return;
      }

      try {
        await handleOAuthCallback(token);
        const returnTo = sessionStorage.getItem('authReturnTo') || '/dashboard';
        sessionStorage.removeItem('authReturnTo');
        navigate(returnTo, { replace: true });
      } catch (err: any) {
        setError(err.message || 'Authentication failed');
        setProcessing(false);
        setTimeout(() => {
          navigate('/auth/login', { replace: true });
        }, 2000);
      }
    };

    processOAuthCallback();
  }, [searchParams, navigate, handleOAuthCallback]);

  if (error) {
    return (
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        height: '100vh',
        fontFamily: 'var(--font-family-sans)'
      }}>
        <div style={{ color: 'var(--color-error)', fontSize: '18px', marginBottom: '8px' }}>
          {error}
        </div>
        <div style={{ color: 'var(--color-text-tertiary)', fontSize: '14px' }}>
          Redirecting to login...
        </div>
      </div>
    );
  }

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center', 
      height: '100vh',
      fontFamily: 'var(--font-family-sans)'
    }}>
      <div style={{ 
        width: '40px', 
        height: '40px', 
        border: '3px solid var(--color-line)',
        borderTopColor: 'var(--color-job)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: '16px'
      }} />
      <div style={{ color: 'var(--color-text-secondary)', fontSize: '16px' }}>
        Completing sign in...
      </div>
      <style>
        {`
          @keyframes spin {
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </div>
  );
};

export default OAuthCallbackPage;
